import React, { MouseEventHandler, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import cn from "classnames";
import SVG from "src/utils/SVG";
import styled from "styled-components";

interface INoticeListProps {
  data?: any;
  onClick?: MouseEventHandler<HTMLButtonElement> | any;
}

const NoticeListItem = (props: INoticeListProps) => {
  const [datas, setDatas] = useState([]);

  useEffect(() => {
    setDatas(props.data.data.data);
  }, [props.data]);

  return (
    <>
      {/* 일반 리스트 */}
      {datas.length > 0 ? (
        <>
          {datas.map((v: any, idx: any) => {
            return (
              <li key={idx}>
                <NoticeListItemSet to={`/notice-detail/` + v.notice_idx}>
                  <div className="top-area">
                    <span className="cate">{v.cate_name}</span>
                    {v.end_date && <span className="end-date">{moment(v.end_date).format("YYYY.MM.DD")} 마감</span>}
                  </div>
                  <p className="title">{v.title}</p>
                  <div className="add-info">
                    <div>
                      <span className="name">{v.vmd_name}</span>
                      <span className="date">{moment(v.insert_date).format("YYYY.MM.DD")}</span>
                    </div>
                    <div>
                      <span className={cn("chat", { new: v.comment_read_yn === "N" })}>
                        {v.comment_read_yn === "N" ? (
                          <SVG name="chatActive" width={12.967} height={13.205} viewBox="0 0 12.967 13.205" />
                        ) : (
                          <SVG name="chat" width={12.967} height={13.205} viewBox="0 0 12.967 13.205" />
                        )}
                        {v.commentCount}
                      </span>
                    </div>
                  </div>
                </NoticeListItemSet>
              </li>
            );
          })}
        </>
      ) : (
        <NoResult>리스트 결과가 없습니다.</NoResult>
      )}
    </>
  );
};

const NoticeListItemSet = styled(Link)`
  display: block;
  .top-area {
    ${({ theme }) => theme.flexBox.flexMixin()}
    .end-date {
      color: ${({ theme }) => theme.color.tertiary};
      font-weight: 500;
      line-height: 20px;
      color: ${({ theme }) => theme.color.warning};
      font-family: "Poppins";
      font-weight: 400;
    }
  }
  .title {
    ${({ theme }) => theme.textOverflow.singleLine()}
    margin-top: 10px;
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    & + .add-info {
      margin-top: 9px;
    }
  }
  .add-info {
    ${({ theme }) => theme.flexBox.flexMixin()}
    color: ${({ theme }) => theme.color.tertiary};
    font-weight: 500;
    line-height: 20px;
    .date {
      padding-left: 16px;
      font-family: "Poppins";
      font-weight: 400;
    }
    .chat {
      padding-left: 4px;
      flex-shrink: 0;
      color: #747474;
      font-family: "Poppins";
      font-weight: 400;
      &.new {
        color: ${({ theme }) => theme.color.subMain};
      }
      > svg {
        position: relative;
        left: -4px;
        top: -1px;
      }
    }
  }
`;

const NoResult = styled.li`
  margin: 80px 0 40px;
  text-align: center;
`;

export default NoticeListItem;
